// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"4eeb7bc7","274":"8ca5e8a0","735":"20beb230","928":"45241efc"}[chunkId] + ".chunk.js";
};